"use client";

import { usePathname } from 'next/navigation'
import { useEffect, useMemo, useState } from 'react'
import Button from '../button';
 
export const NavLink = ({ href, activeClass, children, ...rest }) => {
  const pathname = usePathname();
  const isActive = useMemo(() =>{
    const cleanPath = pathname.split('?')[0].split('#')[0];
    const cleanHref = href.split('?')[0].split('#')[0];

    return cleanPath.replace(/\/$/, "") === cleanHref.replace(/\/$/, "")
  }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname]
  );
  const [props, setProps] = useState(rest);
 
  useEffect(() => {
    if (isActive) {
      const currentCustomClass = rest.customClass !== undefined ? rest.customClass : '';
      const tempProps = {
        ...rest,
        customClass: `${activeClass} ${currentCustomClass}`,
      }
      setProps(tempProps);
    }

    return () => {
      setProps(rest);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);
 
  return (
    <Button href={href} {...props}>
      {children}
    </Button>
  );
}